import React, {useState} from 'react';
import { useDrop } from 'react-dnd';
import {AdminDnDCard} from './AdminDnDCard';
import {produce} from 'immer';
import {moveItemInArray} from "~/helpers/utils";

import './admindnd.scss';

const AdminDndList = ({list, selected = 0, onChanged, onSelect, draggable = true, ...rest}) => {

    const [cards, setCards] = useState(list);

    const moveCard = (id, atIndex) => {

        const { card, index } = findCard(id);

        let newCards = produce(cards, (draft) => {
            moveItemInArray(draft, index, atIndex);
        });

        setCards(newCards);

        if (onChanged) {
            onChanged(newCards);
        }
    };

    const findCard = (id) => {
        const card = cards.filter((c) => `${c.id}` === id)[0];
        return {
            card,
            index: cards.indexOf(card),
        };
    };

    const [, drop] = useDrop({ accept: 'card' });

    if (!cards || !cards.length) {
        return <></>;
    };

    return (
        <div className="admin-dnd-list" ref={drop}>
            {cards.map((card) => (
                <AdminDnDCard
                    key={card.id}
                    selected={selected === card.id}
                    id={`${card.id}`}
                    text={card.name}
                    onClick={onSelect}
                    moveCard={moveCard}
                    findCard={findCard}
                    draggable={draggable}
                />
            ))}
        </div>
    );
}

export default AdminDndList;
